import './src/polyfill';
import './src/modal';
import './src/share';
import './src/scroll';
